import SlsTracker from "@aliyun-sls/web-track-browser";
import json from "./version.json";

const win = global as any;

const opts = {
  host: "cn-zhangjiakou.log.aliyuncs.com", // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
  project: "jianguoke", // Project名称。
  logstore: "uba", // Logstore名称。
  time: 10, // 发送日志的时间间隔，默认是10秒。
  count: 10, // 发送日志的数量大小，默认是10条。
  topic: "exampaper", // 自定义日志主题。
  source: win.location.hostname,
  tags: {
    ua: navigator.userAgent,
    referer: document.referrer,
  },
};
const tracker = new SlsTracker(opts);

export function setDefaults(obj: any) {
  tracker.getOpt().tags = {
    ...tracker.getOpt().tags,
    ...Object.keys(obj).reduce((acc: any, key) => {
      if (obj[key] !== undefined && obj[key] !== null) {
        acc[key] = obj[key].toString();
      }
      return acc;
    }, {}),
  };

  tracker.send({
    page: document.title,
    eventName: "open",
  });
}

/**
 * 记录用户行为
 *
 * @export
 * @param {string} eventName
 * @param {{ action: string; name: string; value: any }} data
 */
export function trace(
  eventName: string,
  data: { name: string; value?: any; [key: string]: any }
) {
  // console.log(eventName, data);
  tracker.send({
    eventName,
    page: document.title,
    ...Object.keys(data).reduce((acc: any, key) => {
      if (data[key] !== undefined && data[key] !== null) {
        acc[key] = data[key].toString();
      }
      return acc;
    }, {}),
  });
}

export function useClickTrace(
  name: string,
  onClick?: (e?: any) => void,
  value?: any
) {
  function handleClick(...params: any) {
    trace("click", { name, value });
    if (onClick) {
      onClick(...params);
    }
  }
  return { onClick: handleClick };
}

export function useChangeTrace(name: string, onChange?: (e?: any) => void) {
  function handleChange(changedValue: any) {
    trace("change", { name, value: changedValue });
    if (onChange) {
      onChange(changedValue);
    }
  }
  return { onChange: handleChange };
}

// 在页面加载完成后启动空闲计时器
win.document.addEventListener("DOMContentLoaded", () => {
  setDefaults(json);
});
